import { BASE } from "./index";
import axios from "./http";

const biexport = {

    //城市仓导出订单
    tdcorderexport: (params) =>
        axios.post(`${BASE.EXPORT_CENTER}/bi/tdc/order/export`, params),
    //客户导出
    salelistexport: (params) =>
        axios.post(`${BASE.EXPORT_CENTER}/bi/tdc/sale/list/export`, params),
    //订单导出
    saleorderlistexport: (params) =>
        axios.post(`${BASE.EXPORT_CENTER}/bi/tdc/sale/order/list/export`, params),

    //城市仓导出结算管理列表
    tdcsettlementlistexport: (params) =>
        axios.post(`${BASE.EXPORT_CENTER}/bi/tdc/settlement/list/export`, params),
    //城市仓导出结算管理详情
    tdcsettlementdetailexport: (params) =>
        axios.post(`${BASE.EXPORT_CENTER}/bi/tdc/settlement/detail/export`, params),
    //自提点导出订单
    deliveryorderexport: (params) =>
        axios.post(`${BASE.EXPORT_CENTER}/bi/delivery/order/export`, params),
    //大促活动提报商品列表导出
    activityproductexport: (params) =>
        axios.post(`${BASE.EXPORT_CENTER}/bi/promotion/activity/product/export`, params),
    //供货单导出
    orderlistexport: (params) =>
        axios.post(`${BASE.EXPORT_CENTER}/bi/supplier/order/list/export`, params),
    //供应商拉黑-导出
    blacklistmemberexport: (params) =>
        axios.post(`${BASE.EXPORT_CENTER}/bi/supplier/blacklist/member/export`, params),
    //供应商拉黑-导出
    discountlistexport: (params) =>
        axios.post(`${BASE.EXPORT_CENTER}/bi/logistics/discount/list/export`, params),
    //动账明细列表-导出
    flowlistexport: (params) =>
        axios.post(`${BASE.EXPORT_CENTER}/bi/tdc/flow/list/export`, params),
    //售后扣款导出-导出
    as_list_export: (params) =>
        axios.post(`${BASE.EXPORT_CENTER}/bi/tdc/flow/as_list/export`, params),
    //城市仓推广奖励结转导出
    promotion_list_export: (params) =>
        axios.post(`${BASE.EXPORT_CENTER}/bi/tdc/flow/promotion_list/export`, params),
    //城市仓推广奖励结转导出
    coupon_list_export: (params) =>
        axios.post(`${BASE.EXPORT_CENTER}/bi/tdc/flow/coupon_list/export`, params),
    //品控复核列表-导出
    entruckQcListExport: (params) =>
        axios.post(`${BASE.EXPORT_CENTER}/bi/entruck/qc/list/export`, params),
    //品控复核线上列表-导出
    entruckQcOnlineListExport: (params) =>
        axios.post(`${BASE.EXPORT_CENTER}/bi/entruck/qc/online/list/export`, params),
    //送货记录-导出
    supplierOrderDeliverRecordExport: (params) =>
        axios.post(`${BASE.EXPORT_CENTER}/bi/supplier/order/deliver/record/export`, params),
};
export default biexport;
